<script lang="ts">
  import { stringTemplateHelper } from "@shared/common/utils/string-template-helper";
  import { getStore } from "../../../context";
  const { dataMap, t } = getStore();

  export let label: string = "";
  export let required: boolean = false;
  export let htmlFor: string | undefined = undefined;
</script>

<label class="form-label" for={htmlFor}>
  <p>
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html stringTemplateHelper({ mode: "VIEW", t: $t }).render(
      label,
      $dataMap
    )}
  </p>
  {#if required}
    <span class="form-label-required">({$t("common.inputRequired")})</span>
  {/if}
</label>

<style>
  .form-label-required {
    font-weight: 400;
    margin-left: calc(var(--cb-form-font-size) * 0.2);
    flex-shrink: 0;
  }

  .form-label {
    display: flex;
    word-break: break-all;
    color: rgba(var(--cb-form-font-color), 1);
    font-weight: 600;
    align-items: center;
    line-height: var(--cb-line-height-md);
    font-size: var(--cb-text-md);
  }
</style>
